import { StyleSheet, View } from "react-native";

import { Backdrop } from "@/components/Artwork";
import { Button } from "@/design/Button";
import { space } from "@/design/tokens";
import { RemotePlaybackTitleBlock } from "@/playback/RemotePlaybackHeroChrome";

export function DisplacedPlaybackPanel({
  artworkUri,
  compact,
  eyebrow,
  fallbackSeed,
  loading,
  onWatchHere,
  title
}: {
  artworkUri: string | null;
  compact: boolean;
  eyebrow: string;
  fallbackSeed: string;
  loading: boolean;
  onWatchHere: () => void;
  title: string;
}) {
  return (
    <View style={styles.panel}>
      {/* Identical background recipe to the casting panel (real artwork via
          Backdrop, no extra scrim layers): the gradient-fallback path bands
          on Samsung hardware when it's the permanently visible state. */}
      <Backdrop uri={artworkUri} fallbackSeed={fallbackSeed} intensity={1} />
      <View style={styles.copy}>
        <RemotePlaybackTitleBlock
          eyebrow={eyebrow}
          numberOfLines={compact ? 2 : 1}
          title={title}
        />
        <View style={{ marginTop: compact ? space.md : space.lg }}>
          <Button
            label="Watch here instead"
            loading={loading}
            onPress={onWatchHere}
            size={compact ? "md" : "lg"}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  panel: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    overflow: "hidden"
  },
  copy: {
    alignItems: "center",
    gap: space.xs,
    maxWidth: "78%"
  }
});
